import { usePage } from "@inertiajs/react"
import type { GiselaTherapist, PageProps } from "@/types/inertia"

// Degrees, registrations and CPD, kept in three groups the way the specialist
// practices present them. All three come from her Therapist record, so they
// stay editable in one place (Admin → Gisela's Profile). Empty groups vanish.
export function CredentialLists({ therapist }: { therapist: GiselaTherapist }) {
  const t = usePage<PageProps>().props.translations.gisela_pages.about

  const groups = [
    { key: "qualifications", label: t.qualifications_label, items: therapist.qualifications },
    { key: "accreditations", label: t.accreditations_label, items: therapist.accreditations },
    { key: "training", label: t.training_label, items: therapist.training },
  ].filter((g) => g.items && g.items.length > 0)

  if (groups.length === 0) return null

  return (
    <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
      {groups.map((group) => (
        <div key={group.key}>
          <h3>{group.label}</h3>
          <ul className="mt-4 m-0 list-none space-y-3 p-0">
            {group.items.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-sage" aria-hidden="true" />
                <span className="text-ink-body">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}
